export const socialLinks = {
	discord: 'https://discord.gg/collabland',
	medium: 'https://medium.com/collab-land',
	twitter: 'https://twitter.com/Collab_Land_',
	linktree: 'https://linktr.ee/collab_land_'
};
